import { lazy } from 'react';

const RELOAD_FLAG = 'byopdf:chunk-reload';

// Tabs opened before a deploy still reference the old chunk hashes, which
// Netlify no longer serves (netlify.toml makes them 404). Reload once to pick
// up the new build; the session flag stops a reload loop if the chunk is
// genuinely broken, in which case the error reaches the error boundary.
export function importWithReload(factory) {
  return factory().then(
    (module) => {
      try { sessionStorage.removeItem(RELOAD_FLAG); } catch (e) { /* storage blocked */ }
      return module;
    },
    (error) => {
      let alreadyReloaded = false;
      try {
        alreadyReloaded = sessionStorage.getItem(RELOAD_FLAG) === '1';
        if (!alreadyReloaded) sessionStorage.setItem(RELOAD_FLAG, '1');
      } catch (e) {
        alreadyReloaded = true;
      }
      const offline = typeof navigator !== 'undefined' && navigator.onLine === false;
      if (!alreadyReloaded && !offline) {
        window.location.reload();
        return new Promise(() => {});
      }
      throw error;
    }
  );
}

export default function lazyWithReload(factory) {
  return lazy(() => importWithReload(factory));
}
